var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 68,
    viewBox: "0 0 82 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_600_2096)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 68,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.0068 52.3878C79.8022 60.8399 69.1418 65.3577 60.773 67.0462C53.321 68.5498 46.6535 63.1345 39.4259 60.7776C33.8115 58.9468 28.4949 57.4344 23.211 54.7974C15.3397 50.869 1.55747 50.4249 1.08107 41.6407C0.5773 32.352 16.3447 31.3883 21.5223 23.66C25.484 17.7466 20.8751 7.62788 26.6529 3.47092C32.3199 -0.606372 40.0184 5.3582 46.9997 5.32957C55.7662 5.29362 67.2031 -3.64603 72.5741 3.2826C78.3152 10.6887 64.478 20.6873 66.064 29.9228C67.6243 39.009 82.3076 43.2608 81.0068 52.3878Z",
    fill: "#6B72C9",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0321 27.4355C20.0109 27.6132 20 27.7941 20 27.9775V46.8853C20 49.3835 22.0252 51.4086 24.5234 51.4086H56.4766C58.9748 51.4086 61 49.3835 61 46.8853V27.9775C61 25.4793 58.9748 23.4541 56.4766 23.4541H24.5234C24.2417 23.4541 23.966 23.4799 23.6986 23.5291L27.3508 27.1814H56.4766C56.9163 27.1814 57.2727 27.5378 57.2727 27.9775V46.8853C57.2727 47.3249 56.9163 47.6814 56.4766 47.6814H24.5234C24.0837 47.6814 23.7273 47.3249 23.7273 46.8853V31.1307L20.0321 27.4355Z",
    fill: "#C3C7F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 21.5908,
    width: 3.72727,
    height: 11.1818,
    rx: 0.452339,
    fill: "#C3C7F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2727 17.8636C57.2727 16.8344 56.4383 16 55.4091 16H25.5909C22.5031 16 20 18.5031 20 21.5909C20 24.6787 22.5031 27.1818 25.5909 27.1818H55.4091C56.4383 27.1818 57.2727 26.3474 57.2727 25.3182V25.3182C57.2727 24.2889 56.4383 23.4545 55.4091 23.4545H25.5909C24.5617 23.4545 23.7273 22.6202 23.7273 21.5909C23.7273 20.5617 24.5617 19.7273 25.5909 19.7273H55.4091C56.4383 19.7273 57.2727 18.8929 57.2727 17.8636V17.8636Z",
    fill: "#C3C7F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.8633,
    y: 25.3184,
    width: 35.4091,
    height: 24.2273,
    fill: "#C3C7F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.589 41.7728C38.3016 41.7728 37.6583 42.3055 37.6583 43.3704C37.6583 43.8851 37.8249 44.2855 38.1574 44.5708C38.4899 44.8561 38.9674 45 39.589 45C40.2114 45 40.6897 44.8531 41.0266 44.5606C41.3636 44.268 41.5332 43.8713 41.5332 43.3704C41.5332 42.8624 41.3666 42.4687 41.0341 42.19C40.7016 41.9112 40.2197 41.7728 39.589 41.7728Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4884 30.0161C43.4812 29.3389 42.1198 29 40.4042 29C38.6984 29 37.0844 29.2847 35.5579 29.8464C34.7016 30.157 35.0857 30.8613 35.0872 30.8649L35.4294 31.4422C35.4294 31.4422 35.8336 31.9942 36.7048 31.7228C36.7138 31.7203 36.7168 31.7215 36.725 31.7185C37.1016 31.5915 37.4827 31.4735 37.8697 31.3694C38.5788 31.1792 39.3492 31.0834 40.1816 31.0834C41.1006 31.0834 41.8052 31.2424 42.2961 31.5596C42.787 31.8769 43.0314 32.332 43.0314 32.9249C43.0314 33.433 42.8797 33.87 42.5778 34.2372C42.276 34.6044 41.6042 35.1191 40.5626 35.7819C39.6877 36.3321 39.0742 36.8649 38.7238 37.3795C38.3733 37.8948 38.1985 38.5408 38.1985 39.3167C38.1649 39.8814 39.0578 39.9939 39.0578 39.9939H39.5972C39.5972 39.9939 40.6239 39.9988 40.7808 39.286C40.7831 39.2764 40.7868 39.2734 40.789 39.2637C40.8249 38.8123 40.9534 38.4384 41.1858 38.1525C41.4615 37.8136 42.0077 37.3868 42.8214 36.8715C43.7756 36.2719 44.4473 35.7849 44.8366 35.4111C45.2259 35.0372 45.5181 34.6442 45.7108 34.2312C45.9036 33.8182 46 33.3475 46 32.8184C45.9985 31.6282 45.4956 30.6934 44.4884 30.0161Z",
    fill: "#F6F6F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_600_2096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 68,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletEmpty);
export default __webpack_public_path__ + "static/media/wallet-empty.d1414f0e.svg";
export { ForwardRef as ReactComponent };